// --------------------------------------------------------------
// Created On: 2025-07-16
// Author: Dimitra Weinstein
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React, { Fragment } from "react";

// A single row in the search device list, displaying device information and providing buttons for subscription and status details.
export default function SearchDeviceListRow(props: Props): Component {
  return (
    <Fragment>
      <tr>
        <td data-test="search-result-device-identifier" className="d-none d-lg-table-cell">
          {props.deviceIdentifier}
        </td>
        <td data-test="search-result-device-type" className="d-none d-lg-table-cell">
          {props.deviceType}
        </td>
        <td data-test="search-result-activation-status" className="d-none d-lg-table-cell">
          {props.activationStatus}
        </td>
        <td data-test="search-result-asset-name" className="d-none d-lg-table-cell">
          {props.assetName}
        </td>
        <td data-test="search-result-subscription-info" className="d-none d-lg-table-cell">
          <button
            data-test="search-result-subscription-info-button"
            className="btn btn-sm btn-primary"
            onClick={() => props.onShowSubscriptionModal(true)}
          >
            Subscription Status
          </button>
        </td>
        <td data-test="search-result-status-info" className="d-none d-lg-table-cell">
          <button
            data-test="search-result-status-info-button"
            className="btn btn-sm btn-primary"
            onClick={() => props.onShowStatusModal(true)}
          >
            Status Info
          </button>
        </td>
      </tr>
    </Fragment>
  );
}

interface Props {
  deviceId: number;
  deviceIdentifier: string;
  deviceType: string;
  statuses: Status[];
  deviceStatuses: DeviceStatus[];
  activationStatus: string;
  assetName: string;
  subscriptionType: string;
  subscriptionStartDate: string;
  subscriptionExpiry: string;
  subscriptionNumber: string;
  onShowSubscriptionModal: (show: boolean) => void;
  onShowStatusModal: (show: boolean) => void;
}

interface Status {
  deviceStatusId: number;
  value: string;
}

interface DeviceStatus {
  code: string;
  description: string;
  deviceStatusId: number;
  name: string;
  value: string;
}
